import {
  createApi,
  fetchBaseQuery,
  type BaseQueryFn,
  type FetchArgs,
  type FetchBaseQueryError,
  type FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query/react'

import { showSubscriptionError } from '../../shared/ui/subscription-modal-emitter'
import { appConfig } from '../config/app-config'
import { browserTokenStorage } from '../auth/browser-token-storage'
import { sessionRejected } from '../auth/session-events'

const rawBaseQuery = fetchBaseQuery({
  baseUrl: appConfig.apiBaseUrl,
  prepareHeaders: (headers) => {
    const accessToken = browserTokenStorage.read()

    if (accessToken) {
      headers.set('authorization', `Bearer ${accessToken}`)
    }

    return headers
  },
})

const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  object,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  const requestToken = browserTokenStorage.read()
  const result = await rawBaseQuery(args, api, extraOptions)

  if (
    result.error?.status === 401 &&
    browserTokenStorage.read() === requestToken
  ) {
    browserTokenStorage.clear()
    api.dispatch(sessionRejected())
  }

  if (result.error) showSubscriptionError(result.error)
  return result
}

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: [
    'Recommendations',
    'Profile',
    'CardSet',
    'Folder',
    'Fsrs',
    'Group',
    'Subscription',
    'Store',
    'ProductAutomation',
    'Notifications',
    'Referrals',
  ],
  endpoints: () => ({}),
})
